import { MediaWithAlbum, SortByQueryOptions } from '@bpm-web-app/stream-api-sdk';
import { Album as DownloadAlbum } from '@bpm-web-app/download-api-sdk';
import { useFeaturedBpmOriginalMedia } from '@bpm-web-app/swr-hooks';
import {
    DEFAULT_HOMEPAGE_TRACKLIST_LIMIT,
    useHubSwitch,
} from '@bpm-web-app/utils';
import { useContext, useMemo, useEffect } from 'react';
import { LibraryTabsContext } from '../../../../utils/src/lib/library-tabs.context';
import { HomepageTracklistSection } from '../shared';
import { TrackListPresetSupreme } from '../shared/track-list/supreme/track-list-supreme-helpers';

export interface FeaturedBpmOriginalProps {
    isDataLoaded?: boolean;
    setIsDataLoaded?: (loaded: boolean) => void;
}

export function FeaturedBpmOriginal({ isDataLoaded, setIsDataLoaded }: FeaturedBpmOriginalProps) {
    const { libraryProperty } = useContext(LibraryTabsContext);
    const { isDownload } = useHubSwitch();
    const { data, isLoading } = useFeaturedBpmOriginalMedia({
        limit: 20,
        sort_by: SortByQueryOptions.DateDesc,
        library: libraryProperty,
    });
    const searchFeaturedBpmOriginal = data?.data.slice(0, DEFAULT_HOMEPAGE_TRACKLIST_LIMIT);

    useEffect(() => {
        if (setIsDataLoaded) {
            if (isLoading === false && searchFeaturedBpmOriginal) {
                setIsDataLoaded(true);
            } else {
                setIsDataLoaded(false);
            }
        }
    }, [isLoading, searchFeaturedBpmOriginal, setIsDataLoaded]);

    const shouldDisplayGhostLoading = useMemo(() => isDataLoaded === false || isLoading, [isDataLoaded, isLoading]);

    return (
        <HomepageTracklistSection
            title="Exclusives"
            href="/exclusives/all"
            list={searchFeaturedBpmOriginal as DownloadAlbum[] | MediaWithAlbum[]}
            preset={isDownload ? TrackListPresetSupreme.Download : TrackListPresetSupreme.Stream}
            isLoading={shouldDisplayGhostLoading}
        />
    );
}

export default FeaturedBpmOriginal;
